export enum MenuItemArea {
  NAVBAR = 'NAVBAR',
  FOOTER = 'FOOTER',
}
